import type { Organization } from '~publish/legacy/organizations/types'

import entitlements from '../formatters/entitlements'

type ParsedOrganization = Organization & {
  hasContentFeature: boolean
}

type OrganizationData = {
  id: string
  locked: boolean
  selected: boolean
  name: string
  ownerEmail: string
  planName: string
  planBase: string
  profileLimit: number
  profilesCount: number
  canManageChannels: boolean
  isOwner: boolean
  isOneBufferOrganization: boolean
  entitlements: string[]
}

export default (orgData: OrganizationData): ParsedOrganization => ({
  id: orgData.id,
  locked: orgData.locked,
  selected: orgData.selected,
  name: orgData.name,
  ownerEmail: orgData.ownerEmail,
  plan: orgData.planName,
  planBase: orgData.planBase,
  profileLimit: orgData.profileLimit,
  profilesCount: orgData.profilesCount,
  canManageChannels: orgData.canManageChannels,
  isOwner: orgData.isOwner,

  // Plan Features
  hasBitlyFeature: orgData.entitlements.includes(entitlements.CUSTOM_BITLY),

  has30DaySentPostsLimitFeature: orgData.entitlements.includes(
    entitlements.SENT_POSTS_30_DAYS,
  ),

  hasCustomizingUtmParamsFeature:
    orgData.entitlements.includes(entitlements.CUSTOMIZE_UTM_PARAM) &&
    orgData.isOwner,

  hasApprovalFeature: orgData.entitlements.includes(entitlements.APPROVAL_FLOW),
  hasGridFeature: orgData.entitlements.includes(entitlements.SHOP_GRID),
  hasStoriesFeature: orgData.entitlements.includes(entitlements.STORIES),

  hasTwitterImpressions: orgData.entitlements.includes(
    entitlements.TWITTER_IMPRESSIONS,
  ),

  hasAnalyticsOnPosts: orgData.entitlements.includes(
    entitlements.ANALYTICS_ON_POSTS,
  ),

  hasFirstCommentFeatureForLinkedin: orgData.entitlements.includes(
    entitlements.FIRST_COMMENT_LINKEDIN,
  ),

  hasFirstCommentFeature: orgData.entitlements.includes(
    entitlements.FIRST_COMMENT,
  ),

  hasShareNextFeature: orgData.entitlements.includes(entitlements.SHARE_NEXT),

  hasUserTagFeature: orgData.entitlements.includes(
    entitlements.TAG_USERS_IN_IMAGES,
  ),

  hasHashtagManagerFeature: orgData.entitlements.includes(
    entitlements.HASHTAG_MANAGER,
  ),

  hasProfileGroupsFeature: orgData.entitlements.includes(
    entitlements.CHANNEL_GROUPS_IN_COMPOSER,
  ),

  hasContentFeature: orgData.entitlements.includes(entitlements.CONTENT),

  canReconnectChannels: orgData.canManageChannels,

  shouldShowUpgradeButton:
    orgData.isOneBufferOrganization &&
    orgData.isOwner &&
    (orgData.planBase === 'one-buffer-free' ||
      orgData.planBase === 'one-buffer-essentials'),

  shouldShowNBMigrationModal: !orgData.isOneBufferOrganization,
})
